<template>
  <div class="center-container">
    <div class="container">
      <div class="loading" v-if="loading">
        <p>...Loading user data...</p>
      </div>
      <template v-else>
        <div class="button-panel">
          <button class="home-button" @click="goToHomepage()">
            HOME
          </button>
        </div>
        <div v-if="user">
          <SubPanel :user="user" />
        </div>
        <div v-if="user">
          <UserPanel :user="user" />
        </div>
        <div>
          <ContactPanel />
        </div>
      </template>
    </div>
  </div>
</template>


<script lang="ts">

import { defineComponent, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import UserPanel from '@/components/UserPanel.vue';
import SubPanel from '@/components/SubPanel.vue';
import ContactPanel from '@/components/ContactPanel.vue';
import { useAuthStore } from '@/stores/auth';
import User from '../types/User';
import { useUserStore } from '@/stores/user'


export default defineComponent({
  name: 'SettingsPage',
  components: { UserPanel, SubPanel, ContactPanel },

  setup() {
    const router = useRouter();
    const authStore = useAuthStore();
    const user = ref<User | null>(null);
    const loading = ref(true);
    const apiUrl = process.env.VUE_APP_DJANGO_BACKEND;

    if (!apiUrl) {
      throw new Error('VUE_APP_DJANGO_BACKEND environment variable is not defined');
    }

    onMounted(async () => {
      try {
        authStore.initializeAuthListener();
        const userStore = useUserStore()
        const { session } = authStore;
        const accessToken = session?.access_token;

        if (session) {
            user.value = await userStore.fetchUser()
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        loading.value = false;
      }
    });

    const goToHomepage = () => {
      router.push('/');
    };

    return {
      user,
      loading,
      goToHomepage,
    };
  },
});

</script>

<style scoped>

.loading {
  margin-top: 150px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 50vh; 

}

.center-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100vh; 
}
 
.container {
margin-top: 20px;
width: 400px;
background-color: white;
padding: 10px; 
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
border-radius: 8px;
        }


.button-panel {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem; /* optional spacing */
}

.home-button {
  background: none;
  border: 2px solid #A1E3F9;
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  padding: 0.6rem 1.2rem;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: #A1E3F9;
}

.home-button:hover {
  border-color: #578FCA;
  background-color: #578FCA;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

</style>



